module.exports = __webpack_public_path__ + "img/empty-kitchener-red.808a8d7.svg";